import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/NEWS') => `${reducer}/${actionType}`;

export const fetchAllNews = () => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const $list = res.info.DATA.filter((item) => item.ISVISIBLE === 'Y') || [];
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.news,
					$list,
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.news,
					_list: status,
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.news,
					$list: [],
				},
			});
		};

		api.$news_fetchAllContent({ onOK, onStatus, onFail }, { from: 1, to: 10 });
	};
};
